<template>
  <div class="bg-dashboard screen-list">
    <div class="container-visit header">
      <div class="card-top">
        <base-visit-profile :data="resultVisit"></base-visit-profile>
        <btn-visit-plan
          :data="{ plan: resultVisit.planBy, name: resultVisit.planbyName }"
        ></btn-visit-plan>
      </div>
      <VisitDatePlan :data="resultVisit" :action="'views'" />
    </div>

    <div class="container-visit todolist">
      <VisitTodoListViews :todo="resultVisit.todoList" />
    </div>

    <div class="container-visit note">
      <div class="card-visit-note">
        <div class="d-flex">
          <i class="icon-HISTORY-Copy-21 font-42"></i>
          <h3 class="pb-2 text-red pl-3">หมายเหตุ</h3>
        </div>
        <label style="padding: 0px 50px">{{ resultVisit.note }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import VisitDatePlan from '@/components/v2/calendar/VisitDatePlan.vue'
import VisitTodoListViews from '@/components/v2/calendar/VisitTodoListViews.vue'
import BaseVisitProfile from '@/components/v2/ui/BaseVisitProfile.vue'
import { mapState } from 'vuex'
export default {
  components: {
    VisitDatePlan,
    VisitTodoListViews,
    BaseVisitProfile,
  },

  computed: {
    ...mapState({
      accessToken: (state) => state.auth.accessToken,
      location: (state) => state.checkinout.location,
    }),
  },
  data() {
    return {
      customerID: this.$route.params.customerID,
      visitID: this.$route.params.visitID,
      dataVisitDetail: [],
      resultVisit: [],
    }
  },
  methods: {
    getVisitDetail() {
      const formData = JSON.stringify({
        visit_id: parseInt(this.visitID),
        customer_id: parseInt(this.customerID),
        lat_lng: this.location,
      })
      const headers = {
        Authorization: `Bearer ${this.accessToken}`,
        'Content-Type': 'application/json',
      }
      fetch(`${this.$baseAPI}/visit/detail`, {
        method: 'POST',
        body: formData,
        headers: headers,
      })
        .then((response) => {
          return response.json()
        })
        .then((res) => {
          this.dataVisitDetail = res.detail
          this.dataFormatVisitDetail()
        })
        .catch((error) => {
          console.log(error)
        })
    },

    dataFormatVisitDetail() {
      const data = this.dataVisitDetail
      const result = this.displayVisitDetail(data)
      this.resultVisit = result
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch('setTitle', 'เข้าเยี่ยม')
      this.$store.dispatch('checkinout/getLocation')
    })

    // set background
    const wrap = document.querySelectorAll('.v-application--wrap')
    wrap[0].style.backgroundColor = '#eef3fa'

    this.getVisitDetail()
  },
}
</script>

<style lang="scss" src="@/assets/scss/visit/visit-detail.scss"></style>
<style scoped lang="scss">
.card-visit-note {
  border-radius: 8px;
  background-color: #ffffff;
  padding: 30px;
}

textarea {
  padding: 15px;
  margin: 15px 0px;
  border: 1px solid #bdbdbd;
}

.icon-HISTORY-Copy-21:before {
  content: '\e98f';
  color: #868585;
}
</style>
